import type { SVGProps } from 'react';
const DialogCloseSvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m15 15 10.5 10.5M15 25.5 25.5 15"
    />
  </svg>
);
export default DialogCloseSvgIcon;
